import { render, staticRenderFns } from "./insurance-acknowledge.vue?vue&type=template&id=0833e5f0&"
import script from "./insurance-acknowledge.vue?vue&type=script&lang=js&"
export * from "./insurance-acknowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports